<template>
  <v-dialog
    v-model="isVisible"
    :overlay="false"
    fullscreen
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card v-if="data">
      <v-toolbar
        class="rounded-0"
        color="secondary"
        dark
        extended
        extension-height="40"
        flat
        height="60"
        max-height="100"
      >
        <v-avatar color="blue-grey lighten-1">
          <v-icon
            dark
            medium
          >
            {{ $t(`Payment.Dialog.View.Toolbar.Icon`) }}
          </v-icon>
        </v-avatar>

        <v-toolbar-title class="pl-3">
          <div class="body-3">
            {{ $t(`Payment.Dialog.View.Toolbar.Title`) }} #{{ data?.TransactionId }} (#{{ data?.Id }})
          </div>

          <div class="text-caption grey--text">
            {{ terminalName }}
          </div>
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          dark
          icon
          @click="isVisible = false"
        >
          <v-icon>close</v-icon>
        </v-btn>

        <template #extension>
          <v-tabs
            v-model="tab"
            background-color="secondary"
            class="rounded-0"
            dark
            grow
            show-arrows
            slider-color="white"
          >
            <v-tab
              class="cyan darken-2"
              value="tab-transaction"
            >
              TRANSACTION
            </v-tab>

            <v-tab
              class="cyan darken-2"
              value="tab-sale"
            >
              SALE
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-card-text class="pa-0 fill-height">
        <v-tabs-items
          v-model="tab"
          class="fill-height"
        >
          <v-tab-item
            key="tab-transaction"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightTransaction"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item
            key="tab-sale"
            style="background-color: #1E1F22; color: #B7BBC1; overflow-y: auto; height: 100vh;"
          >
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <pre
                    v-safe-html="syntaxHighlightSale"
                    style="user-select: text;"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import {syntaxHighlight} from '@/lib/helper/helper'
import TerminalsCommon from '@/mixins/payments/terminalsCommon.js'

export default {
  name      : 'TransactionRawDataDetailsDialog',
  components: {},
  mixins    : [Auth, AppData, TerminalsCommon],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    data: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      tab: 'tab-transaction'
    }
  },
  computed: {
    terminalName() {
      const terminal = this.getTerminal(this.data?.TerminalVendorId, this.data?.TerminalModelId)
      return terminal ? `${this.data?.TerminalNickname} / ${terminal.Manufacturer} - ${terminal.Model}` : ''
    },

    syntaxHighlightTransaction() {
      return syntaxHighlight(this.data?.Data?.Transaction)
    },

    syntaxHighlightSale() {
      return syntaxHighlight(this.data?.Data?.Sale)
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible(val) {
      this.tab = 'tab-transaction'
      this.rawDataDialogVisible = false
      if (this.$refs.body) this.$refs.body.scrollTop = 0
    }
  },
  updated() {
  },
  methods: {}
}
</script>

<style scoped>
:deep(pre) {
  outline: 1px solid #B7BBC1;
  padding: 5px;
  margin: 5px;
}
</style>
